import { render, staticRenderFns } from "./ReceiptRefundsReportButtons.vue?vue&type=template&id=6b08007c&"
import script from "./ReceiptRefundsReportButtons.vue?vue&type=script&lang=js&"
export * from "./ReceiptRefundsReportButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b08007c')) {
      api.createRecord('6b08007c', component.options)
    } else {
      api.reload('6b08007c', component.options)
    }
    module.hot.accept("./ReceiptRefundsReportButtons.vue?vue&type=template&id=6b08007c&", function () {
      api.rerender('6b08007c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/ReceiptRefundsReportButtons.vue"
export default component.exports